import { render, staticRenderFns } from "./test_help_info.vue?vue&type=template&id=c2a67284&scoped=true"
import script from "./test_help_info.vue?vue&type=script&lang=js"
export * from "./test_help_info.vue?vue&type=script&lang=js"
import style0 from "./test_help_info.vue?vue&type=style&index=0&id=c2a67284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a67284",
  null
  
)

export default component.exports